import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { Loader2Icon } from 'lucide-react';

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
    const { t } = useTranslation();
    return (
        <Loader2Icon
            role="status"
            aria-label={t('common.loading', 'Loading')}
            className={cn('size-4 animate-spin text-primary-500', className)}
            {...props}
        />
    );
}

export { Spinner };
